export default __webpack_public_path__ + "static/media/last2.cec9d167.jpg";